import React, { useState } from "react";

import styled from "styled-components/macro";
import { useNavigate, useLocation } from "react-router-dom";
import AwsUpload from "./../../utils/AwsUpload";
import { Grid, Typography, Box } from "@mui/material";
import { useAxios } from "../../hooks/";
import pages from "../../constants/pages";
import {
  OuterBox,
  SubheaderSection,
  LoadingButton,
  ButtonContainer,
} from "./../../components";

const Preview = styled.video`
  width: 100%;
  height: 300px;
`;

export default function VideoPreview({ userData }) {
  const axios = useAxios();

  const navigate = useNavigate();
  const location = useLocation();
  const { visitor_id } = location.state || {};

  const [loading, setLoading] = useState(false);
  const [livelinessError, setLivelinessError] = useState([]);

  function captureAgain() {
    navigate(pages.checkLiveliness.route, {
      state: {
        visitor_id: visitor_id,
      },
    });
  }

  const checkingLiveliness = async () => {
    setLoading(true);
    const fileurl = await AwsUpload(userData.state.blob, "video");
    // const fileurl =
    //   "https://dc-chat-media.s3.ap-south-1.amazonaws.com/sample_data_files/1692246547202.webm";
    axios({
      url: `/booking/appointment/verify/liveness`,
      method: "POST",

      data: {
        video_url: fileurl,
        visitor_id: sessionStorage.getItem("visitorId"),
      },
    })
      .then((response) => {
        if (response.status && response.data.status) {
          proceedToNext(fileurl);
        } else {
          setLoading(false);
          const steps = response.message.displayMessage.split(/\s(?=\d\.)/);
          setLivelinessError(steps);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error in Aws upload:", error);
      });
  };

  function proceedToNext(fileurl) {
    setLoading(true);
    const userPayloadString = localStorage.getItem("userPayload");
    const userPayload = JSON.parse(userPayloadString);
    axios({
      url: "/booking/appointment/verification",
      method: "PATCH",
      data: {
        livliness_check_status: 1,
        livliness_video_url: fileurl,
        ...userPayload,
        visitor_id: sessionStorage.getItem("visitorId"),
        id: sessionStorage.getItem("id"),
      },
    })
      .then((response) => {
        if (response.status) {
          console.log(response.data);

          const destination = `${pages.Success.route}?ref-id=${response.data.ref_id}&booking-type=${userPayload.booking_type}`;
          navigate(destination);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error update verification detils:", error);
      });
  }

  var blob = URL.createObjectURL(userData.state.blob);
  return (
    <OuterBox>
      <SubheaderSection
        textAlign="left"
        title="Liveness Verification"
        content=" Before proceeding, check the video preview"
      />

      <form>
        <Box>
          <Grid item xs={6} style={{ textAlign: "center" }}>
            <Preview controls src={blob} />
          </Grid>

          {livelinessError.length > 0 && (
            <Grid
              sx={{
                padding: "10px",
              }}
            >
              <Typography variant="h6" sx={{ color: "red", mb: 2 }}>
                Verification Failed
              </Typography>
              {livelinessError.map((step, index) => (
                <Typography key={index} variant="body1">
                  {step === "face found"
                    ? "Face detected but unable to verify liveness. Kindly try again"
                    : ` ${step}`}
                  <br />
                </Typography>
              ))}
            </Grid>
          )}

          {loading && (
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ marginBottom: "16px" }}
            >
              It may take a few seconds
            </Typography>
          )}
        </Box>

        <ButtonContainer>
          {!livelinessError.length > 0 && (
            <LoadingButton loading={loading} onClick={checkingLiveliness}>
              Proceed Next
            </LoadingButton>
          )}

          <LoadingButton
            onClick={captureAgain}
            backgroundColor="gray"
            disabled={loading}
          >
            Capture Again
          </LoadingButton>
        </ButtonContainer>
      </form>
    </OuterBox>
  );
}
